import { lazaiMainnet } from '@/common-helpers/lazaiMainnetChain';
import { lazaiTestnet } from '@/common-helpers/lazaiTestnetChain';
import { andromeda } from '@/common-helpers/metisChain';
import { metisSepolia } from '@/common-helpers/metisSepoliachain';
import { bsc, bscTestnet } from 'viem/chains';

export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000';

export enum ChainId {
    metisTestnet = 59902,
    metisMainnet = 1088,

    lazaiMainnet = 52924,
    lazaiTestnet = 133718,

    bscMainnet = 56,
    bscTestnet = 97,
}

export const SupportChainIDs: ChainId[] =
    import.meta.env.VITE_SUPPORT_CHAIN_IDS.split(',').map(Number) || [
        ChainId.lazaiMainnet,
    ];

export const DefaultChainId: ChainId = SupportChainIDs[0];

export const NETWORK_CONFIG = {
    [ChainId.lazaiTestnet]: {
        name: lazaiTestnet.name,
        scanLable: lazaiTestnet.blockExplorers.default.name,
        explore: lazaiTestnet.blockExplorers.default.url,
        chainConfig: lazaiTestnet,
    },
    [ChainId.lazaiMainnet]: {
        name: lazaiMainnet.name,
        scanLable: lazaiMainnet.blockExplorers.default.name,
        explore: lazaiMainnet.blockExplorers.default.url,
        chainConfig: lazaiMainnet,
    },
    [ChainId.metisTestnet]: {
        name: metisSepolia.name,
        scanLable: metisSepolia.blockExplorers.default.name,
        explore: metisSepolia.blockExplorers.default.url,
        chainConfig: metisSepolia,
    },
    [ChainId.metisMainnet]: {
        name: andromeda.name,
        scanLable: andromeda.blockExplorers.default.name,
        explore: andromeda.blockExplorers.default.url,
        chainConfig: andromeda,
    },
    [ChainId.bscMainnet]: {
        name: bsc.name,
        scanLable: bsc.blockExplorers.default.name,
        explore: bsc.blockExplorers.default.url,
        chainConfig: bsc,
    },
    [ChainId.bscTestnet]: {
        name: bscTestnet.name,
        scanLable: bscTestnet.blockExplorers.default.name,
        explore: bscTestnet.blockExplorers.default.url,
        chainConfig: bscTestnet,
    },
};

export const RPC = {
    [ChainId.metisMainnet]: andromeda.rpcUrls.default.http[0],
    [ChainId.metisTestnet]: metisSepolia.rpcUrls.default.http[0],
    [ChainId.lazaiTestnet]: lazaiTestnet.rpcUrls.default.http[0],
    [ChainId.lazaiMainnet]: lazaiMainnet.rpcUrls.default.http[0],
    [ChainId.bscMainnet]: bsc.rpcUrls.default.http[0],
    [ChainId.bscTestnet]: bscTestnet.rpcUrls.default.http[0],
};

export type Token = {
    name: string;
    symbol: string;
    decimals: number;
    address: string;
    img?: string;
};

export enum FaucetToken {
    metis = 'metis',
}

export enum MissionType {
    interactWithAI = 'interactWithAI',
    launchpadParticipation = 'launchpadParticipation',
    twitterFocusLazpad = 'twitterFocusLazpad',
    twitterShareLazpad = 'twitterShareLazpad',
    tgGroupJoin = 'tgGroupJoin',
    joinDiscord = 'joinDiscord',
    aiPlaygroundTasks = 'aiPlaygroundTasks',
    createAIAgent = 'createAIAgent',
}

export const Missions = [
    {
        id: MissionType.interactWithAI,
        title: 'Interact with AI Bot',
        description:
            'Ask insightful questions or complete guided tasks with our AI Assistant.',
        points: 20,
        link: '/aibot',
    },
    {
        id: MissionType.launchpadParticipation,
        title: 'Launchpad Participation',
        description:
            'Successful investments in Main Launchpad projects can earn you points. ',
        points: 12,
        link: '/',
    },
    {
        id: MissionType.twitterFocusLazpad,
        title: 'Follow on X.com',
        description:
            'Follow Lazpad.fun or partner projects on X.com (Twitter).',
        points: 12,
        link: 'https://x.com/CorruptedAlith',
    },
    {
        id: MissionType.twitterShareLazpad,
        title: 'Share Project on X.com',
        description: 'Share Lazpad project details to your X.com followers.',
        points: 20,
        link: 'https://x.com/CorruptedAlith',
    },
    {
        id: MissionType.tgGroupJoin,
        title: 'Join Telegram',
        description:
            'Become an active member of the Lazpad or partner project communities.',
        points: -1,
        link: 'https://t.me/lazai_global',
    },
    {
        id: MissionType.joinDiscord,
        title: 'Join Discord',
        description:
            'Become an active member of the Lazpad or partner project communities.',
        points: -1,
        link: 'https://discord.gg/lazpad',
    },
    {
        id: MissionType.aiPlaygroundTasks,
        title: 'AI Playground Tasks',
        description:
            'Explore and interact with various AI Agents, complete unique tasks.',
        points: -1,
        link: '/',
    },
    {
        id: MissionType.createAIAgent,
        title: 'Create AI Agent',
        description:
            'Create your own AI Agent or be an early trader on the bonding curve.',
        points: -1,
        link: '/',
    },
];

export const MetisAddress = '0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000';

export const OFFICIAL_X = 'https://x.com/LazAINetwork';

export const OFFICIAL_TELEGRAM = 'https://t.me/lazai_global';

export const LAZAI_TELEGRAM = 'https://t.me/lazai_global';

export const FAUCET = 'https://faucet.lazai.network';

export const BRIDGE =
    'https://nexus.hyperlane.xyz/?origin=metis&token=METIS&destination=lazai';

export const ShowSelectNetwork =
    import.meta.env.VITE_SHOW_SELECTNETWORK === 'true';

export const isBSCNetwork =
    SupportChainIDs.includes(ChainId.bscMainnet) ||
    SupportChainIDs.includes(ChainId.bscTestnet);

export const isLazaiNetwork =
    SupportChainIDs.includes(ChainId.lazaiMainnet) ||
    SupportChainIDs.includes(ChainId.lazaiTestnet);
